/* eslint-disable import/prefer-default-export */
import { ErrorReport } from '../lib/errorReports';

import api from '../lib/baseAxios';

export const sendErrorReport = async (payload: ErrorReport) => {
  return api.post(`/analytics/error`, payload);
};
